export enum Theme {
  Green = 'green-theme',
  Light = 'light-theme',
  Teal = 'teal-theme',
}
